import { useState, useEffect, useRef } from "react";
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL ? `${process.env.REACT_APP_BACKEND_URL}/api` : '/api';

/**
 * Hook to fetch and combine admin photos with hardcoded photos for a service
 * @param {string} serviceKey - The service key (e.g., "aannemer", "badkamer")
 * @param {Array} basePhotos - Array of hardcoded photo objects with { src, alt }
 * @returns {Array} Combined array of photos
 */
export function useServicePhotos(serviceKey, basePhotos = []) {
  const [photos, setPhotos] = useState(basePhotos);
  const basePhotosRef = useRef(basePhotos);

  useEffect(() => {
    basePhotosRef.current = basePhotos;
  }, [basePhotos]);

  useEffect(() => {
    if (!serviceKey) return;
    
    axios.get(`${API}/website-photos/${serviceKey}`)
      .then(res => {
        const adminPhotos = res.data || [];
        if (adminPhotos.length > 0) {
          const baseUrl = process.env.REACT_APP_BACKEND_URL || '';
          const formattedAdminPhotos = adminPhotos.map(p => ({
            src: p.url.startsWith('http') ? p.url : `${baseUrl}${p.url}`,
            alt: p.alt || `${serviceKey} project foto`
          }));
          setPhotos([...basePhotosRef.current, ...formattedAdminPhotos]);
        }
      })
      .catch(() => {
        // Keep base photos on error
      });
  }, [serviceKey]);

  return photos;
}
